import React from "react";
import {Button, SxProps, Theme, Typography} from "@mui/material";
import {darken} from "@mui/material/styles";

interface RegisterButtonProps {
    text?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    sx?: SxProps<Theme>;
    margin?: string | number;
    padding?: string | number;
    backgroundColor?: string;
}

const RegisterButton: React.FC<RegisterButtonProps> = ({
                                                           text,
                                                           sx = {},
                                                           margin,
                                                           padding,
                                                           backgroundColor = "#BA6973",
                                                       }) => {
    return (
        <Button
            variant="contained"
            onClick={() => {
                window.location.href = 'https://forms.office.com/e/X3yd36cNkk';
            }}
            sx={{
                bgcolor: backgroundColor,
                textTransform: "none",
                px: 4,
                py: 1.5,
                borderRadius: "10px",
                margin: margin,
                padding: padding,
                "&:hover": {
                    bgcolor: darken(backgroundColor, 0.1),
                },
                ...sx,
            }}
        >
            <Typography
                color={'#FFFFFF'}
                sx={{
                    fontFamily: (theme) => theme.typography.button.fontFamily,
                    fontWeight: (theme) => theme.typography.button.fontWeight,
                    fontSize: () => 16,
                }}
            >
                {text}
            </Typography>
        </Button>
    );
};

export default RegisterButton;
